/*********************** Custom JS for Boost AI Search & Discovery  ************************/

const customize = {
   updateProductItemGrid: (componentRegistry) => {
      componentRegistry.useComponentPlugin('ProductItem', {
         name: 'Add extra information #280272',
         enabled: true,
         apply: () => ({
            afterRender(element) {
               try {
                  // Start customization--------------------------------------------
                  let productData = element.getParams().props.product;
                  let productId = productData.id;
                  if (productData?.split_product) {
                     productId = productData.variant_id;
                  }
                  let productItem = document.querySelector('[data-product-id="' + productId + '"]');
                  if (productItem) {
                    const low_inventory_threshold = 1;
                    const inventoryHTML = generateInventoryHTML(low_inventory_threshold, productData);
                    if (inventoryHTML && !productItem.querySelector('.product-item__inventory') && productItem.querySelector('.boost-sd__product-price')) {
                       productItem.querySelector('.boost-sd__product-price').insertAdjacentHTML('afterend', inventoryHTML);
                    }
                  }
                  // End-------------------------------------------------------------
               } catch (e) {
                  console.warn(e);
               }
            }
         }),
      });
   }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateProductItemGrid]);

function generateInventoryHTML(low_inventory_threshold, product) {
    let html = '';

    if (product.variants[0].inventory_management && product.template_suffix !== 'pre-order') {
        if (product.available) {
            let shouldCalculateInventory = true;

            // Check if any variant should skip inventory calculation
            for (const variant of product.variants) {
                if (variant.inventory_policy === 'continue' || variant.inventory_management === null) {
                    shouldCalculateInventory = false;
                    break;
                }
            }

            if (shouldCalculateInventory && low_inventory_threshold > 0) {
                let allInventory = 0;

                // Calculate total inventory
                for (const variant of product.variants) {
                    if (variant.inventory_management) {
                        allInventory += Math.max(0, variant.inventory_quantity);
                    }
                }

                if (allInventory <= low_inventory_threshold) {
                    html = `<span class="product-item__inventory inventory inventory--low">Only ${allInventory} ${allInventory > 1 ? 'units' : 'unit'} left</span>`;
                } else {
                    html = `<span class="product-item__inventory inventory inventory--high">In stock, ${allInventory} ${allInventory > 1 ? 'units' : 'unit'}</span>`;
                }
            } else {
                if (product.variants[0].inventory_policy === 'continue' && product.variants[0].inventory_quantity <= 0) {
                    html = `<span class="product-item__inventory inventory inventory--high">Re-stocking soon</span>`;
                } else {
                    html = `<span class="product-item__inventory inventory inventory--high">In stock</span>`;
                }
            }
        } else {
            html = `<span class="product-item__inventory inventory">Sold out</span>`;
        }
    }

    return html;
}